import Styles from './Drawer.module.scss'
import { Drawer } from 'vaul'
import React, { forwardRef } from 'react'

type Props = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'ref' | 'className'
> & {
  preventCycle?: boolean
}

export const Handle = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <div className={Styles.handleContainer}>
    <Drawer.Handle className={Styles.handle} ref={ref} {...props}></Drawer.Handle>
  </div>
))
